import React, {
    Component
} from 'react';
import Loader from 'react-loader-spinner';
// import {CardElement, CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe, ReactStripeElements } from 'react-stripe-elements';
import {
    CardElement,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
    Elements,
    ElementsConsumer
} from "@stripe/react-stripe-js";
import {
    loadStripe
} from "@stripe/stripe-js";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "../../../custom-css/Custom.css";

const utilizeScroll = () => {
    const htmlElRef = React.createRef();
    const executeScroll = () => {
        // console.log("Y-Coord: ", htmlElRef.current.offsetTop);
        window.scrollTo(0, htmlElRef.current.offsetTop);
    }

    return {
        executeScroll,
        htmlElRef
    }
}

let stripe_apiKey = ''
let BASE_URL = "";

if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
) {
    BASE_URL = "http://localhost:8001";
} else if (window.location.hostname === "dev.cocoonsealy.net") {
    BASE_URL = "https://dev.cocoonsealy.net";
} else if (window.location.hostname === "cocoonbysealy.io") {
    BASE_URL = "https://cocoonbysealy.io";
} else if (window.location.hostname === "staging.cocoonbysealy.ca") {
    BASE_URL = "https://staging.tempurcloud.ca";
} else if (window.location.hostname === "cocoonbysealy.ca") {
    BASE_URL = "https://cocoonbysealy.ca";
}

if (window.location.hostname === 'cocoonbysealy.ca') {
    stripe_apiKey = 'pk_live_BLqlUVtwKf3HJrpgarS3ViDR00MqML3EOD'
} else {
    stripe_apiKey = 'pk_test_G0W0zyFQv55BfbOIpNukOxda00WYcdQbK1'
}

class PaymentForm extends Component {
    constructor(props) {
        super(props);
        this.elScroll = utilizeScroll();
        this.state = {
            hideShow: false,
            errorMessages: '',
            name: '',
            postal: '',
            currency: 'cad',
            loading: false,
        }
    }

    handleSubmit = async evt => {
        evt.preventDefault();
        // const stripe = useStripe();
        const {
            stripe,
            elements
        } = this.props;
        const card_holder_name = document.getElementById("card_holder_name");
        const postal = document.getElementById("postal");
        const cardNumberElement = elements.getElement(CardNumberElement);
        const cardExpiryElement = elements.getElement(CardExpiryElement);
        const cardCvcElement = elements.getElement(CardCvcElement);

        this.props.lprops.props.disable_payment_button(true);
        if (stripe) {
            const data = {
                name: card_holder_name.value,
                address_zip: postal.value,
                address_country: this.props.lprops.props.billing_country !== undefined ?
                    this.props.lprops.props.billing_country : "",
                currency: this.state.currency
            };

            // console.log('token data', data);
            try {
                const {
                    token
                } = await stripe.createToken(cardNumberElement, data);

                if (token !== undefined) {
                    if (token.error) {
                        this.setState({
                            hideShow: true,
                            errorMessage: token.error.message
                        });
                    } else {
                        this.setState({
                            hideShow: false
                        });
                        this.stripeTokenHandler(token);
                    }
                } else {
                    this.props.lprops.props.disable_payment_button(false);
                }
            } catch (e) {
                throw e;
            }
        }
    }

    // Submit the form with the token ID.
    stripeTokenHandler = (token) => {
        // console.log(`Token is ...`, token)
        // console.log(`Token ID is ...`, token.id)
        // Insert the token ID into the form so it gets submitted to the server
        const form = document.getElementById('payment-form');
        let hiddenInput = document.createElement('input');
        hiddenInput.setAttribute('type', 'hidden');
        hiddenInput.setAttribute('name', 'stripeToken');
        hiddenInput.setAttribute('value', token.id);
        form.appendChild(hiddenInput);

        // Submit the form
        form.submit();
    }

    handleChange = ({
        error
    }) => {
        if (error) {
            this.setState({
                errorMessage: error.message,
                hideShow: true
            });
        } else {
            this.setState({
                hideShow: false
            });
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        // console.log(this.state);
    }

    componentDidMount = () => {
        this.elScroll.executeScroll();
    }

    render() {
        return ( <
            React.Fragment > {
                /*<!-- Stripe Payment FOrm --> */
            } <
            div ref = {
                this.elScroll.htmlElRef
            }
            className = "checkout-step checkout-step--payment-method form" >
            <
            h2 className = "checkout-step__heading" > 4. {
                this.props.userlang === 'fr' ? 'Paiement' : 'Payment'
            } < /h2> <
            div className = {
                this.props.submit_payment ? "checkout-step__body checkout-step__body--collapsed" : "checkout-step__body"
            } >
            <
            div className = "form__field" > < /div> <
            div className = "checkout-step__payment-enabled-fields" > < /div> <
            div className = "checkout-step__payment-method" >
            <form
                className="checkout-step__payment-form"
                onSubmit={this.handleSubmit}
              >
                <div>
                  <h4 className="checkout-step__bar-heading">&nbsp;</h4>
                  <div className="checkout-step__form-container checkout-step__form-container--cc checkout-step__form-container--blue">
                    <div className="checkout-step__form-header">
                      <div className="checkout-step__form-header--cc-copy">
                        <div className="checkout-step__copy--bold">
                          {this.props.lprops.props.userlang === "fr"
                            ? "Paiement sécurisé par carte de crédit"
                            : "Secure Credit Card Payment"}
                        </div>
                        <div>
                          {this.props.lprops.props.userlang === "fr"
                            ? "Utilisez votre carte VISA, MasterCard ou American Express"
                            : "Use your VISA, MasterCard, or American Express card"}
                          .
                        </div>
                      </div>
                      <div className="checkout-step__form-header--cc-image">
                        <img
                          src="/static/bundles/f3bb1bf319b92fbc870d47b2069d1ca9-coc.png"
                          className="checkout-step__form-image--cc responsive-img"
                          alt=""
                        />
                      </div>
                    </div>
                    <div
                      className={
                        this.state.hideShow ? "error" : "error hide-show"
                      }
                      role="alert"
                    >
                      {this.state.errorMessage}
                    </div>
                    <fieldset style={{ border: 0 }}>
                      <div className="checkout-step__copy--bold">
                        {this.props.lprops.props.userlang === "fr"
                          ? "Nom sur la carte de crédit"
                          : "Name on Credit Card"}
                        <sup>*</sup>
                      </div>
                      <div className="form__field form__field--optional form__field--text form__field--card_number stripe_input">
                        <input
                          className=""
                          id="card_holder_name"
                          name="card_holder_name"
                          autoComplete="given-name"
                          maxLength="100"
                          onChange={e =>
                            this.setState({ name: e.target.value })
                          }
                        />
                      </div>
                      <div className="checkout-step__copy--bold">
                        {this.props.lprops.props.userlang === "fr"
                          ? "Numéro de la carte"
                          : "Card Number"}
                        <sup>*</sup>
                      </div>
                      <div className="form__field form__field--optional form__field--text form__field--card_number stripe_input">
                        <CardNumberElement
                          className="stripe_extra"
                          onChange={this.handleChange}
                        />
                      </div>
                      <div className="checkout-step__payment-cc-expiration">
                        <div className="checkout-step__copy--bold">
                          {this.props.lprops.props.userlang === "fr"
                            ? "Date d'expiration (MM/AA)"
                            : "Expiration (MM/YY)"}
                          <sup>*</sup>
                        </div>
                        <div className="form__field form__field--optional form__field--text form__field--card_expiration stripe_input">
                          <CardExpiryElement
                            className="stripe_extra"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="checkout-step__payment-cc-code">
                        <div className="checkout-step__copy--bold">
                          {this.props.lprops.props.userlang === "fr"
                            ? "Code de sécurité"
                            : "Security Code"}
                          <sup>*</sup>
                        </div>
                        <div className="form__field form__field--optional form__field--text form__field--card_cvc stripe_input">
                          <CardCvcElement
                            className="stripe_extra"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="checkout-step__payment-cc-code postal_code">
                        <div className="checkout-step__copy--bold">
                          {this.props.lprops.props.userlang === "fr"
                            ? "Code postal"
                            : "Postal Code"}
                          <sup>*</sup>
                        </div>
                        <div className="form__field form__field--optional form__field--text form__field--card_cvc stripe_input">
                          <input
                            id="postal"
                            name="postal"
                            maxLength="7"
                            type="text"
                            placeholder="1B1 2C2"
                            className="StripeElement"
                            required
                            onChange={e =>
                              this.setState({ postal: e.target.value })
                            }
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div className="form__field form__field--submit">
                  <input
                    type="submit"
                    className="button button--full-width button--place-order checkout-place-order-button--cc"
                    value={
                      this.props.lprops.props.userlang === "fr"
                        ? "Passer la commande"
                        : "Place Order"
                    }
                    disabled={
                      this.props.lprops.props.submit_payment ||
                      this.props.lprops.props.paymentType === ""
                        ? true
                        : false
                    }
                  />
                </div>
              </form> < /
            div > <
            /div> <
            div className = {
                this.props.submit_payment ? "checkout-step__summary " : "checkout-step__summary checkout-step__summary--collapsed"
            } >
            <
            p > {
                this.props.userlang === 'fr' ? 'Payer par carte de crédit' : 'Paying via Credit Card'
            } < /p> <
            p > < strong > {
                this.props.userlang === 'fr' ? 'Veuillez NE PAS cliquer sur le bouton RETOUR de votre navigateur, votre paiement est en cours de traitement.' : 'Please do NOT click on the BACK button on your browser, your payment is being processed.'
            } < /strong></p >
            <
            div className = "loading-spinner l-capped-width" >
            <
            div className = "loading-spinner__inner" >
            <
            div className = "sk-fade-in sk-spinner sk-three-bounce" >
            <
            Loader type = "ThreeDots"
            color = "#f9bd4f"
            height = {
                80
            }
            width = {
                80
            }
            visible = {
                this.props.submit_payment
            }
            className = "myload" / >pa
            <
            div > < /div> <
            div > < /div> <
            div > < /div> < /
            div > <
            /div> < /
            div > <
            /div> < /
            div > {
                /* <!-- End of Stripe Payment FOrm --> */
            } <
            /React.Fragment>
        );
    }
}

const InjectedCheckoutForm = props => (
  <ElementsConsumer>
    {({ stripe, elements }) => (
      <PaymentForm stripe={stripe} elements={elements} lprops={props} />
    )}
  </ElementsConsumer>
);

const stripePromise = loadStripe(stripe_apiKey);
const stripeElementOptions = {
  locale: "ca"
};

const PaymentFormApp = props => (
  <Elements stripe={stripePromise}>
    <InjectedCheckoutForm props={props} />
  </Elements>
);

export default PaymentFormApp;
